import type { HardcodedNavSection } from "../layouts/sidebar/types";
import { canAccessFeature, canAccessModule, type ModulePermissions } from "./modulePermissions";

export function filterNavSections(
  sections: HardcodedNavSection[],
  permissions: ModulePermissions | null | undefined,
): HardcodedNavSection[] {
  return sections
    .map((section) => {
      if (!canAccessModule(permissions, section.module)) {
        return null;
      }

      const filteredChildren = section.children.filter((child) =>
        canAccessFeature(permissions, child.module, child.feature),
      );

      if (section.children.length > 0 && filteredChildren.length === 0) {
        return null;
      }

      return { ...section, children: filteredChildren };
    })
    .filter((section): section is HardcodedNavSection => section !== null);
}
